<template>
  <div class='mainContainer'>
    <div class='tabs'>
      <div @click='typeFun(0)' class='left' :class='{ active: type === 0 }'>库场及其他结算</div>
      <div @click='typeFun(6)'  class='right' :class='{ active: type === 6 }'>库场及其他补结算</div>
    </div>
    <div class='nav' v-if="type === 0">
      <el-form :model='searchForm' label-width='130px' :inline='true'>
        <el-form-item label='供应商：'>
          <el-input v-model='searchForm.supplierName' size='mini' placeholder='请输入供应商' />
        </el-form-item>
        <el-form-item label='港口/库房名称：'>
          <el-input v-model='searchForm.name' size='mini' placeholder='请输入港口/库房名称' />
        </el-form-item>
        <el-form-item label='结算类型：'>
          <el-select v-model='searchForm.settlementType' size='mini' filterable style='width:100%'
                     placeholder='请选择结算类型' value-key='id'>
            <el-option label='全部' value='' />
            <el-option label='库房' :value='0' />
            <el-option label='港口' :value='1' />
          </el-select>
        </el-form-item>
        <el-form-item label='台账月：'>
          <el-date-picker v-model='searchForm.standingBookMonth' size='mini' value-format='yyyy-MM'
                          type='month' placeholder='请选择台账月' />
        </el-form-item>
        <el-form-item label='品牌：'>
          <el-input v-model='searchForm.brand' size='mini' placeholder='请输入品牌' />
        </el-form-item>
        <el-form-item label='补结算对账编号：' label-width="130px">
          <el-input v-model='searchForm.actNoAdd' size='mini' placeholder='请输入补结算对账编号'  style="width: 170px"/>
        </el-form-item>
        <el-form-item label='补结算对账标题：' label-width="130px">
          <el-input v-model='searchForm.titleAdd' size='mini' placeholder='请输入补结算对账标题' />
        </el-form-item>
        <el-form-item label='是否生成对账单:'>
          <el-select v-model='searchForm.isReconciliation' size='mini' placeholder='请选择是否生成对账单'>
            <el-option label='全部' value='' />
            <el-option label='是' :value='1' />
            <el-option label='否' :value='0' />
            <el-option label='部分生成' :value='2' />
          </el-select>
        </el-form-item>
        <el-form-item label='是否生成补结算:' label-width='130px'>
          <el-select v-model='searchForm.isAdd' size='mini' placeholder='请选择是否生成补结算'>
            <el-option label='全部' value='' />
            <el-option label='是' :value='1' />
            <el-option label='否' :value='0' />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size='small' style='margin-left: 10px;' class='searchBtn' @click='searchBtn'>
            查询
          </el-button>
          <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
          <el-button size='small' type='primary' @click='generateStatement'>生成对账单</el-button>
          <el-button size='small' type='primary' @click='refreshSettlement'>刷新结算</el-button>
<!--          <el-button size='small' type='primary' @click='modifyLedgerMonth'>修改台账月</el-button>-->
        </el-form-item>
      </el-form>
    </div>
    <el-row v-if="type === 0">
      <el-col :span='24' style='text-align: end;font-size: 14px!important;' class='exportButton'>
        <div style='display: flex;justify-content: flex-end;'>
          <span @click='download'>模板下载</span>
          <batch-import :uploadUrl='uploadUrl' @importSuccess='searchBtn' />
          <span @click='exportData'>导出数据</span>
        </div>
      </el-col>
    </el-row>
    <div class='content' v-if="type === 0">
      <el-table
        ref='registerTable'
        row-key='id'
        v-loading='tableLoading'
        :data='tableData'
        style='width: 100%'
        border
        :header-cell-style='headerCellStyle'
        :reserve-selection='true'
        @select='selectionChange'
        @select-all='selectionChange'
        :row-style="rowStyle">
        <el-table-column type='selection' align='center' min-width='50'
                         :selectable='(row)=>{return row.isReconciliation !== 1}' />
        <el-table-column label='供应商' prop='supplierName' align='center' />
        <el-table-column label='结算类型' prop='settlementType' align='center'
                         :formatter='settlementTypeFormat' />
        <el-table-column label='港口/库房名称' prop='name' align='center' width="130"/>
        <el-table-column label='台账月' prop='standingBookMonth' align='center' />
        <el-table-column label='作业时间' prop='taskDate' align='center' />
        <el-table-column label='品牌' prop='brand' align='center' />
        <el-table-column label='作业类型' prop='taskType' align='center' />
        <el-table-column label='作业数量' prop='taskNum' align='center' />
        <el-table-column label='结算方式' prop='settlementStyle' align='center'
                         :formatter='settlementStyleFormat' />
        <el-table-column label='税率（%）' prop='taxRate' align='center' width='100' />
        <el-table-column label='含税金额' prop='taxPrice' align='center' />
        <el-table-column label='不含税金额' prop='price' align='center' width='100' />
        <el-table-column prop='isAdd' label='是否生成补结算' align='center' width='180' :formatter="isAddFormat"/>
        <el-table-column label='是否生成对账单' prop='isReconciliation' align='center' width="150"
                         :formatter='isReconciliationFormat' />
        <el-table-column prop='settNo' label='对账单编号' width='160px' align='center'
                         show-overflow-tooltip/>
        <el-table-column prop='title' label='对账单标题' width='180px' align='center'
                         show-overflow-tooltip>
          <template slot-scope='scope'>
            {{ scope.row.title ? scope.row.title : '--' }}
          </template>
        </el-table-column>
        <el-table-column prop='actNoAdd' label='补结算对账编号' width='160px' align='center'
                         show-overflow-tooltip/>
        <el-table-column prop='titleAdd' label='补结算对账标题' width='160px' align='center'
                         show-overflow-tooltip/>
      </el-table>
      <div class='paginationContainer'>
        <el-pagination
          background
          :page-sizes='[10, 20, 30, 40]'
          layout='total, sizes, prev, pager, next, jumper'
          :total='total'
          @size-change='contractSizeChange'
          @current-change='contractCurrentChange'
          :current-page.sync='searchForm.page'
          :page-size='searchForm.rows'
        />
      </div>
    </div>

    <!-- 生成对账单 -->
    <generate-statement ref='generateStatementRef' @clearSelectedData='clearSelectedData' />
    <!-- 修改台账月 -->
    <modify-ledger-month ref='modifyLedgerMonthRef' @clearSelectedData='clearSelectedData' />
    <!-- 库场及其他补结算 -->
    <supplier-supplementary-settlement  v-if="type === 6"/>
  </div>
</template>

<script>
  import GenerateStatement
    from '@/views/settle/supplier/supplier-port-warehouse-settlement/components/generateStatement';
  import ModifyLedgerMonth
    from '@/views/settle/supplier/supplier-port-warehouse-settlement/components/modifyLedgerMonth';
  import {
    supplierPortWarehouseSettlementList,
    supplierPortWarehouseSettlementRefresh,
  } from '@/service/warehouse';
  import { getSessionStore } from '@/config/mUtils';
  import { baseUrl } from '@/config/env';
  import BatchImport from '@/components/batchImport';
  import supplierSupplementarySettlement from './components/supplierSupplementarySettlement.vue'

  export default {
    name: 'supplierPortWarehouseSettlement',
    components: {
      ModifyLedgerMonth,
      GenerateStatement,
      BatchImport,
      supplierSupplementarySettlement
    },
    data() {
      return {
        type: 0,
        searchForm: {
          supplierName: '',
          name: '',
          settlementType: '',
          standingBookMonth: '',
          brand: '',
          isReconciliation: '',
          isAdd: '', // 是否生成补结算
          actNoAdd: '', //补结算对账编号
          titleAdd: '',
          page: 1,
          rows: 10,
        },
        defaultSearchForm: {},
        tableLoading: false,
        tableData: [],
        headerCellStyle: {
          'color': '#3B3B3B',
          'font-size': '13px',
          'height': '48px',
          'background': '#E8E8E8',
        },
        total: 0,
        xxxOptions: [{
          value: 1,
          label: 1,
        }, {
          value: 2,
          label: 2,
        },
        ],
        selectedData: [],
        tipOne: true,
        settlement: '',
        uploadUrl: '/settlement/supplierPortAndWarehouse/importExcel',
      };
    },
    mounted() {
      this.defaultSearchForm = JSON.parse(JSON.stringify(this.searchForm));
      //this.searchBtn();
    },
    methods: {
      /**
       * 生成对账单
       */
      generateStatement() {
        if (this.selectedData.length === 0) return this.$message.warning('请选择数据后生成对账单');
        let taxFlag = false; // 税率
        if (this.selectedData.length > 0) {
          const {
            taxRate,
          } = this.selectedData[0];
          this.selectedData.forEach((item) => {
            if (item.taxRate !== taxRate) {
              taxFlag = true;
            }
          });
        }
        if (taxFlag) return this.$message.warning('部分数据税率不相等！');
        this.$refs.generateStatementRef.dialogOpen(this.selectedData);
      },
      /**
       * 刷新结算
       */
      async refreshSettlement() {
        this.tableLoading = true;
        const res = await supplierPortWarehouseSettlementRefresh();
        this.tableLoading = false;
        if (res.status !== 0) return this.$message.warning(res.message);
        this.$message.success(res.message);
        await this.getTableData();
      },
      /**
       * 修改台账月
       */
      modifyLedgerMonth() {
        if (!this.selectedData.length || this.selectedData.length === 0) return this.$message.warning('请选择至少一条数据！');
        if (this.selectedData.length > 100) return this.$message.warning('最多选择100条数据！');
        this.$refs.modifyLedgerMonthRef.dialogOpen(this.selectedData);
      },
      // 结算类型格式化
      settlementTypeFormat(row, column, cellValue) {
        switch (cellValue) {
          case 0:
            return '库房';
          case 1:
            return '港口';
        }
      },
      // 结算方式格式化
      settlementStyleFormat(row, column, cellValue) {
        switch (cellValue) {
          case 0:
            return '预结算价';
          case 1:
            return '合同价';
        }
      },
      // 是否生成对账单格式化
      isReconciliationFormat(row, column, cellValue) {
        switch (cellValue) {
          case 0:
            return '否';
          case 1:
            return '是';
          case 2:
            return '部分生成';
        }
      },
      // 是否生成补结算格式化
      isAddFormat(row, column, cellValue) {
        switch (cellValue) {
          case 0:
            return '否';
          case 1:
            return '是';
          case null:
            return '否';
        }
      },
      download() {
        window.location.href = '/file/港口库房供应商结算导入模板.xlsx';
      },
      //库场及其他结算/库场及其他补结算切换
      typeFun(val) {
        this.type = val;
        this.$nextTick(() => {
          this.total = 0;
        });
      },
      // 查询
      searchBtn() {
        this.searchForm.page = 1;
        this.getTableData();
      },
      // 重置
      resetBtn() {
        this.searchForm = JSON.parse(JSON.stringify(this.defaultSearchForm));
      },
      // 获取表格数据
      async getTableData() {
        this.tableLoading = true;
        const {
          status,
          message,
          data,
        } = await supplierPortWarehouseSettlementList(this.searchForm);
        this.tableLoading = false;
        if (status !== 0) return this.$message.warning(message);
        this.tableData = data.records;
        this.total = data.total;
      },
      /**
       * 删除
       * @param id 当前选中数据 id
       */
      deleteData(id) {
        this.$confirm('确认删除当前数据？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
          })
          .catch(() => {
          });
      },
      /**
       * 提交/批量提交
       * @param id 当前选中数据 id
       */
      batchSubmission(id) {
        this.$confirm('确认提交当前选中数据？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            console.log(id);
            this.selectedData = [];
            this.$refs.registerTable.clearSelection();
          })
          .catch(() => {
          });
      },
      rowStyle({ row }) {
        return this.selectedData.includes(row) ? { background: 'rgb(197 226 255)' } : {};
      },
      selectionChange(selectionRow) {
        if (!this.tipOne) {
          this.tipOne = true;
          this.selectedData = [];
          this.$refs.registerTable.clearSelection();
        } else {
          this.selectedData = selectionRow;
          let supplierName = '', // 供应商
            settlementType = '', // 类算类型
            settlementStyle = ''; // 结算方式
          const array = selectionRow.filter((item, index) => {
            if (index === 0) {
              supplierName = item.supplierName;
              settlementType = item.settlementType;
              settlementStyle = item.settlementStyle;
            }
            console.log(supplierName, settlementType);
            return supplierName !== item.supplierName || settlementType !== item.settlementType || settlementStyle !== item.settlementStyle;
          });
          console.log(array);
          // 筛选  供应商相同数据
          this.selectedData = selectionRow.filter(item => supplierName === item.supplierName && settlementType === item.settlementType && settlementStyle === item.settlementStyle);
          console.log(this.selectedData);
          array.forEach((value) => {
            // 只有使用表格原数据，才会生效   从表格原数据中赛选
            if (this.tipOne) {
              this.$message.warning('只能选择相同的供应商和结算类型');
              this.tipOne = false;
            }
            this.$refs.registerTable.toggleRowSelection(this.tableData.find(item => value.id === item.id), false);
          });
        }
      },
      contractSizeChange(row) {
        this.searchForm.rows = row;
        this.searchForm.page = 1;
        this.getTableData();
      },
      contractCurrentChange(page) {
        this.searchForm.page = page;
        this.getTableData();
      },
      clearSelectedData() {
        this.selectedData = [];
        this.$refs.registerTable.clearSelection();
        this.searchBtn();
      },
      // 导出数据
      exportData() {
        // let token = getSessionStore('token');
        const {
          supplierName,
          name,
          settlementType,
          standingBookMonth,
          brand,
          isReconciliation,
          isAdd,
          actNoAdd,
          titleAdd,
        } = this.searchForm;
        // window.location.href = `${baseUrl}/platform/settlement/supplierPortAndWarehouse/exportExcel?access_token=${token}&supplierName=${supplierName}&name=${name}&settlementType=${settlementType}&standingBookMonth=${standingBookMonth}&brand=${brand}&isReconciliation=${isReconciliation}&isAdd=${isAdd}&actNoAdd=${actNoAdd}&titleAdd=${titleAdd}`;
        window.exportExcelGet('/platform/settlement/supplierPortAndWarehouse/exportExcel', `supplierName=${supplierName}&name=${name}&settlementType=${settlementType}&standingBookMonth=${standingBookMonth}&brand=${brand}&isReconciliation=${isReconciliation}&isAdd=${isAdd}&actNoAdd=${actNoAdd}&titleAdd=${titleAdd}`)
      },
    },
  };
</script>


<style lang='scss' scoped>
  .mainContainer {
    width: 100%;
    padding: 20px 15px 0 15px;
    //background-color: #fff;
    height: 0;
    .tabs {
      float: left;
      margin-left: 20px;
      margin-top: 2px;
      display: flex;
      justify-content: space-between;
      width: 339px;
      margin-bottom: 20px;

      div {
        //background: #ccc;
        width: 120px;
        height: 30px;
        line-height: 30px;
        color: #48599E;
        text-align: center;
        font-size: 13px;
        cursor: pointer;
        border: 1px solid #48599E;
        font-weight: 700;
        transition: all .3s;
      }

      .left {
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
      }

      .right {
        /*width: 160px;*/
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
        margin-right: 100px;
      }

      .active {
        background: #48599E;
        color: #fff;
      }
    }
    .nav {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      &Btn {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
      }
    }

    .content {
      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-top: 10px;

        span {
          font-size: 13px;
        }
      }
    }
  }
</style>
